// Převod souřadnic IFC (Z nahoru, metry, SKUTEČNÉ souřadnice souboru) <-> scéna Three.js.
//
// IfcLoader (That Open) načítá s COORDINATE_TO_ORIGIN = true: web-ifc posune model
// k počátku a posun uloží do group.coordinationMatrix; FragmentsManager pak všechny
// další modely federace zarovná do rámce PRVNÍHO modelu (baseCoordinationMatrix).
// Scéna = baseCoordinationMatrix · IFC(Y nahoru) + federationOffset. Bez zpětného
// použití matice by „IFC souřadnice" vieweru byly posunuté a BCF/řezy z jiných
// nástrojů (Solibri, Revit, AI kontrola IDS) by mířily jinam.
import * as THREE from "three";

function isMatrix(m) { return m && m.elements && m.elements.length === 16; }

export function sceneToIfc(p, baseMatrix, offset) {
  const q = new THREE.Vector3(p.x, p.y, p.z);
  if (offset) q.sub(offset);
  if (isMatrix(baseMatrix)) q.applyMatrix4(baseMatrix.clone().invert());
  return { x: q.x, y: -q.z, z: q.y };
}

export function ifcToScene(p, baseMatrix, offset) {
  const v = new THREE.Vector3(p.x, p.z, -p.y);
  if (isMatrix(baseMatrix)) v.applyMatrix4(baseMatrix);
  if (offset) v.add(offset);
  return v;
}
